/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

import { getTypographyByName } from "theme/typography";

export default function ControlLabel(theme: Theme): any {
  return {
    MuiFormControlLabel: { styleOverrides: { label: { ...getTypographyByName(theme, "body2") } } },
    MuiFormHelperText: { styleOverrides: { root: { marginTop: theme.spacing(1) } } },
    MuiFormLabel: { styleOverrides: { root: { color: theme.palette.text.disabled } } },
  };
}
